import { render, staticRenderFns } from "./ShiftTemplatesList.vue?vue&type=template&id=8fb3c310&scoped=true"
import script from "./ShiftTemplatesList.vue?vue&type=script&lang=js"
export * from "./ShiftTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./ShiftTemplatesList.vue?vue&type=style&index=0&id=8fb3c310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb3c310",
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QBtn});qInstall(component, 'directives', {ClosePopup});
